import React, { useEffect, useState } from "react";
import "./index.scss";
import { Button, Modal, Dropdown, Menu, Spin } from "antd";
import { toast } from "react-toastify";
import Loading from "../../../loading/loading.index";
import { get, post, responseValidator, SITEURL } from "../../../api";
import avatar from "../../../landing/pic/tempProfilePic.png";
import bronzePhoto from '../../../assets/images/bronzeTempPhoto.png'
import silverPhoto from '../../../assets/images/silverTempPhoto.png'
import goldPhoto from '../../../assets/images/goldTempPhoto.png'


export default function Profile() {
    const [pageLoading, setPageLoading] = useState(true);
    const [user, setUser] = useState(null);
    useEffect(() => {
        setPageLoading(true);
        get("/User/Profile/Current").then(response => {
            setPageLoading(false);
            if (responseValidator(response.status)) {
                setUser(response.data.data);
                console.log(response.data.data);
            } else {
                toast.error(response.data.message);
                if (response.status === 403)
                    setTimeout(() => {
                        window.location.replace("/authorization/");
                    }, 3000);
            }
        });
    }, []);







    return (
        <div className="gx-main-content row prof-page">

            {pageLoading && <Loading />}
            <div className="row main-payment">
                <div className="col-12 title-payment">
                    <h3 className="title-text">حساب کاربری</h3>
                    <span />
                    <Button
                        onClick={() =>
                            window.location.replace("/userpanel/verification")
                        }
                        type={"primary"}
                    >
                        ثبت مشخصات
                    </Button>
                </div>
            </div>

            {user && (
                <div
                    style={{ marginTop: "32px" }}
                    className="row ant-card gx-card-widget cc-type"
                >
                    <div className="avatar-div">
                        <img src={user.lastLevel.id === 'Level1' || user.lastLevel.id === 'Level2' ? bronzePhoto : user.lastLevel.id === 'Level3' ? silverPhoto : avatar} alt="Avatar" />
                    </div>
                    <div className="details-div">
                        <div className="user-info-div">
                            <p className="user-info">نام: </p>
                            <h4>
                                {user.firstName == null || user.firstName === ""
                                    ? "تنظیم نشده است"
                                    : user.firstName}
                            </h4>
                        </div>

                        <hr />

                        <div className="user-info-div">
                            <p className="user-info">نام خانوادگی: </p>
                            <h4>
                                {user.lastName == null || user.lastName === ""
                                    ? "تنظیم نشده است"
                                    : user.lastName}
                            </h4>
                        </div>

                        <hr />

                        <div className="user-info-div">
                            <p className="user-info">ایمیل: </p>
                            <h4>
                                {user.email == null || user.email === ""
                                    ? "تنظیم نشده است"
                                    : user.email}
                            </h4>
                        </div>

                        <hr />

                        <div className="user-info-div">
                            <p className="user-info">تاریخ تولد: </p>
                            <h4>
                                {user.birthDate == null || user.birthDate === ""
                                    ? "تنظیم نشده است"
                                    : new Date(
                                        user.birthDate
                                    ).toLocaleDateString("fa-IR")}
                            </h4>
                        </div>

                        <hr />

                        <div className="user-info-div">
                            <p className="user-info">کد ملی: </p>
                            <h4>
                                {user.nationalCode == null ||
                                    user.nationalCode === ""
                                    ? "تنظیم نشده است"
                                    : user.nationalCode}
                            </h4>
                        </div>

                        <hr />

                        <div className="user-info-div">
                            <p className="user-info">شماره تماس: </p>
                            <h4>
                                {user.phoneNumber == null ||
                                    user.phoneNumber === ""
                                    ? "تنظیم نشده است"
                                    : user.phoneNumber}
                            </h4>
                        </div>

                        <hr />

                        <div className="user-info-div">
                            <p className="user-info">تاریخ عضویت: </p>
                            <h4>
                                {new Date(user.registerDate).toLocaleDateString(
                                    "fa-IR"
                                )}
                            </h4>
                        </div>

                        <hr />

                        <div className="user-info-div">
                            <p className="user-info">شماره تلفن ثابت: </p>
                            <h4>
                                {user.landlineNumber == null ||
                                    user.landlineNumber === ""
                                    ? "تنظیم نشده است"
                                    : user.landlineNumber}
                            </h4>
                        </div>

                        <hr />

                        <div className="user-info-div">
                            <p className="user-info">سطح کاربر : </p>
                            <h4>
                                {user.lastLevel.title == null ||
                                    user.lastLevel.title === ""
                                    ? "تنظیم نشده است"
                                    : user.lastLevel.title}
                            </h4>
                        </div>


                        <hr />
                        <div className="user-info-div">
                            <p className="user-info">ربات تلگرام : </p>
                            {user.telegramActive ? (
                                <h4>عضو شده :</h4>
                            ) : (
                                <a
                                    href={"//" + user.telegramJoinLink}
                                    target="_blank"
                                >
                                    {" "}
                                    عضو شوید{" "}
                                </a>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
